module.exports = "/_next/static/images/WirelineConstructionHeroSection-ee3460dfa2b6655bfdd4533172136665.webp";